<template>
  <!-- <div>
    <router-view></router-view>
  </div>-->
  <div class="pageContent">
    <div class="inspectionReport">
      <div class="inspectionContent">
        <div class="dataTitle">
          <van-icon
            class="hospiyalsArrowLeft"
            style="top: 16px;"
            name="arrow-left"
            @click="onBack"
            v-if="forwardingReport"
          />
          <div class="title">
            <div
              class="content"
              v-if="this.$route.query.institution_id !== '73000005'"
              :class="[reportBool ? 'action' : '']"
              @click="toReport"
            >
              检查报告
            </div>
            <div
              class="line"
              v-if="this.$route.query.institution_id !== '73000005'"
            >
              |
            </div>
            <div
              class="content"
              :class="[portraitBool ? 'action' : '']"
              @click="toPortrait"
            >
              数字影像
            </div>
            <!-- <div class="line" v-if="forwardingReport&&examId">|</div>
            <div class="content" @click="toForwarding" v-if="forwardingReport&&examId">转发报告</div>-->
          </div>
        </div>
        <!-- 组件 -->
        <div v-if="reportBool">
          <inspectionReport
            v-if="Storage.get('code') != 2 && Storage.get('examStatus') != 1"
          />
        </div>
        <portrait v-else />
      </div>
    </div>
  </div>
</template>
<script>
//报告
import inspectionReport from "./components/inspectionReport.vue";
import portrait from "./components/portrait.vue";
import Storage from "@/tools/storage";
export default {
  name: "reportInfoOuter_GZ",
  components: { inspectionReport, portrait },
  data() {
    return {
      reportBool: true,
      portraitBool: false,
      forwardingReport: true,
    };
  },
  methods: {
    toReport() {
      this.reportBool = true;
      this.portraitBool = false;
    },
    toPortrait() {
      this.portraitBool = true;
      this.reportBool = false;
    },
    onBack() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (Storage.get("reportPermissions")) {
      this.forwardingReport = false;
    }
  },
  created() {
    if (this.$route.query.institution_id === "73000005") {
      this.portraitBool = true;
      this.reportBool = false;
    }
  },
};
</script>
<style scoped></style>
